import { Map } from 'immutable';
import { LayoutDataItem } from '../../../common/entities';
import { FormItemTypes } from '@bimser/core';

export function removeAdditionalProperties(data: Map<string, LayoutDataItem>, id: string) {
	if (!data.has(id)) {
		return data;
	}

	const item = data.get(id);

	switch (item.type) {
		case FormItemTypes.EControlTypes.Image: {
			data = data.setIn([id, 'properties', 'fileName'], null);
			data = data.setIn([id, 'properties', 'imageBase64'], null);
			break;
		}
	}

	return data;
}
